// extracted by mini-css-extract-plugin
export var gif = "_jf-0";